import React from 'react';
import { Link } from 'react-router-dom';
import ImageWebp from 'react-image-webp';
import Constant from "../../utils/Constant";
import axios from 'axios';
import LocalStorageService from "../../utils/LocalStorageService";
import $ from "jquery";
import Header from "../common/Header";
import Cookies from 'js-cookie';
import { decrypt, key } from '../../utils/encryptiondecryption';

class TopTrending extends React.Component {
  constructor() {
    super();
    //banner
    const ciphertext = Cookies.get('YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD');
    const decryptedText = decrypt(ciphertext, key);
    this.state = {
      fbUrl : "",
      whatsappUrl : "",
      twitterUrl : "",
      googleUrl : "",
      linkedinUrl : "",
      auth: {
        device_id: decryptedText.length > 1 ? (decryptedText[0][1] === 'null' ? null : decryptedText[0][1]) : null,
        phone_details: decryptedText.length > 1 ? (decryptedText[1][1] === 'null' ? null : decryptedText[1][1]) : null,
        user_id: decryptedText.length > 1 ? (decryptedText[2][1] === 'null' ? null : decryptedText[2][1]) : null,
        mobile: decryptedText.length > 1 ? (decryptedText[3][1] === 'null' ? null : decryptedText[3][1]) : null,
        package_id: decryptedText.length > 1 ? (decryptedText[4][1] === 'null' ? null : decryptedText[4][1]) : null,
        subscription_expiry_datetime: decryptedText.length > 1 ? (decryptedText[5][1] === 'null' ? null : decryptedText[5][1]) : null,
      },
    }
  }


  handleProgramList = () => {
    let programs = "";
    let classRef = this;
    // console.log("props trending progs", this.props.data);
    programs = this.props.data.map((program, index) => (
      <div className="TopTenTrendingBox ProgramsCard" key={index} id={"glider_slider_pro" + classRef.props.sliderKey + '_' + index}>
        {
          localStorage.getItem('user_id') ? 
            (
              this.state.auth.user_id ?
              <Link to={"/program/" + program.program_slug}>
                <div className="shows_slider_img">
                  <ImageWebp webp={program.program_thumbnail} src={program.program_thumbnail_jpg} alt={program.program_name} />
                  <div className="chnl_hvr_box"><span uk-icon="play"></span></div>
                </div>
              </Link> : <Link onClick={()=>{ window.location.href = "http://he.mjunoon.tv:8080/register" }}>
                <div className="shows_slider_img">
                  <ImageWebp webp={program.program_thumbnail} src={program.program_thumbnail_jpg} alt={program.program_name} />
                  <div className="chnl_hvr_box"><span uk-icon="play"></span></div>
                </div>
              </Link>
            )
             : (
              this.state.auth.user_id ?
              <Link to={"/register"}>
                <div className="shows_slider_img">
                  <ImageWebp webp={program.program_thumbnail} src={program.program_thumbnail_jpg} alt={program.program_name} />
                  <div className="chnl_hvr_box"><span uk-icon="play"></span></div>
                </div>
              </Link> : <Link onClick={()=>{ window.location.href = "http://he.mjunoon.tv:8080/register" }}>
                <div className="shows_slider_img">
                  <ImageWebp webp={program.program_thumbnail} src={program.program_thumbnail_jpg} alt={program.program_name} />
                  <div className="chnl_hvr_box"><span uk-icon="play"></span></div>
                </div>
              </Link>
             )
        }
      </div>
    ));
    return programs;
  };
  render() {
    return (
      <div>
        <section className="pad_left pad_bh shows_slider_sec ProgramSectionHome">
          <div className="headng_box">
            <h2 className="h2forhome"><strong>{(this.props.type) ? this.props.name + ' ' + this.props.type : this.props.name}</strong></h2>
          {this.props.name !== 'Top Trending Programs' &&this.props.name !== 'Featured Films' ? 
            <Link className="view_all" to={!this.state.auth.user_id ? "/register" : '/' + this.props.name.toLowerCase().replace(/\s+/g, '-') + '/'}>{(window.location.pathname === '/') ? 'View All' : ''}</Link> :''} 
            </div>
          <div className="slider_new_container drama_sldr_container">
            <div className="drama_sldr_new" uk-slider='finite: true; sets: true;'>
              <div className="uk-slider-items">

                {this.handleProgramList()}
              </div>
              <a className="CarouselPrevBtn" href="#" uk-slider-item="previous"><img src="/images/left_arrow.png" alt="right arrow" /></a>
              <a className="CarouselNextBtn" href="#" uk-slider-item="next"><img src="/images/right_arrow.png" alt="right arrow" /></a>
            </div>
          </div>
        </section>
        <hr />
      </div>
    );
  }
}

export default TopTrending;